<script>
export default {
  methods: {
    //修改数据中心
    changeDataCenter(value) {
      this.$store.commit('saveGmt', value)
      this.$router.go(0)
    }
  }
}
</script>

<template>
  <!--多数据中心-->
  <el-dropdown placement="bottom" @command="changeDataCenter">
    <!--当前选中数据中心-->
    <span class="gmt">
      GMT {{ $store.state.gmt.gmt > 0 ? '+' : '' }}{{ $store.state.gmt.gmt }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>

    <!--下拉语言-->
    <el-dropdown-menu slot="dropdown">
      <div class="el-dropdown-menu-box">
        <el-dropdown-item :command="-12" :class="[$store.state.gmt.gmt == -12 ? 'acitve' : '']">GMT -12</el-dropdown-item>
        <el-dropdown-item :command="-11" :class="[$store.state.gmt.gmt == -11 ? 'acitve' : '']">GMT -11</el-dropdown-item>
        <el-dropdown-item :command="-10" :class="[$store.state.gmt.gmt == -10 ? 'acitve' : '']">GMT -10</el-dropdown-item>
        <el-dropdown-item :command="-9" :class="[$store.state.gmt.gmt == -9 ? 'acitve' : '']">GMT -9</el-dropdown-item>
        <el-dropdown-item :command="-8" :class="[$store.state.gmt.gmt == -8 ? 'acitve' : '']">GMT -8</el-dropdown-item>
        <el-dropdown-item :command="-7" :class="[$store.state.gmt.gmt == -7 ? 'acitve' : '']">GMT -7</el-dropdown-item>
        <el-dropdown-item :command="-6" :class="[$store.state.gmt.gmt == -6 ? 'acitve' : '']">GMT -6</el-dropdown-item>
        <el-dropdown-item :command="-5" :class="[$store.state.gmt.gmt == -5 ? 'acitve' : '']">GMT -5</el-dropdown-item>
        <el-dropdown-item :command="-4" :class="[$store.state.gmt.gmt == -4 ? 'acitve' : '']">GMT -4</el-dropdown-item>
        <el-dropdown-item :command="-3" :class="[$store.state.gmt.gmt == -3 ? 'acitve' : '']">GMT -3</el-dropdown-item>
        <el-dropdown-item :command="-2" :class="[$store.state.gmt.gmt == -2 ? 'acitve' : '']">GMT -2</el-dropdown-item>
        <el-dropdown-item :command="-1" :class="[$store.state.gmt.gmt == -1 ? 'acitve' : '']">GMT -1</el-dropdown-item>
        <el-dropdown-item :command="0" :class="[$store.state.gmt.gmt == 0 ? 'acitve' : '']">GMT 0</el-dropdown-item>
        <el-dropdown-item :command="1" :class="[$store.state.gmt.gmt == 1 ? 'acitve' : '']">GMT +1</el-dropdown-item>
        <el-dropdown-item :command="2" :class="[$store.state.gmt.gmt == 2 ? 'acitve' : '']">GMT +2</el-dropdown-item>
        <el-dropdown-item :command="3" :class="[$store.state.gmt.gmt == 3 ? 'acitve' : '']">GMT +3</el-dropdown-item>
        <el-dropdown-item :command="4" :class="[$store.state.gmt.gmt == 4 ? 'acitve' : '']">GMT +4</el-dropdown-item>
        <el-dropdown-item :command="5" :class="[$store.state.gmt.gmt == 5 ? 'acitve' : '']">GMT +5</el-dropdown-item>
        <el-dropdown-item :command="6" :class="[$store.state.gmt.gmt == 6 ? 'acitve' : '']">GMT +6</el-dropdown-item>
        <el-dropdown-item :command="7" :class="[$store.state.gmt.gmt == 7 ? 'acitve' : '']">GMT +7</el-dropdown-item>
        <el-dropdown-item :command="8" :class="[$store.state.gmt.gmt == 8 ? 'acitve' : '']">GMT +8</el-dropdown-item>
        <el-dropdown-item :command="9" :class="[$store.state.gmt.gmt == 9 ? 'acitve' : '']">GMT +9</el-dropdown-item>
        <el-dropdown-item :command="10" :class="[$store.state.gmt.gmt == 10 ? 'acitve' : '']">GMT +10</el-dropdown-item>
        <el-dropdown-item :command="11" :class="[$store.state.gmt.gmt == 11 ? 'acitve' : '']">GMT +11</el-dropdown-item>
        <el-dropdown-item :command="12" :class="[$store.state.gmt.gmt == 12 ? 'acitve' : '']">GMT +12</el-dropdown-item>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style scoped lang="scss">
.gmt{
  cursor: pointer;
}
</style>
